/**
 * Recaptcha Check
 * Used on contact forms (fast-contact, fast-question, huge-deal)
 * @see https://bureaux-a-partager.atlassian.net/browse/MATCH-4032
 * @param recaptchaKey
 * @param formSelector
 * @param e
 * @param beforeSubmit
 * @param actionName
 */
export default function (recaptchaKey, formSelector, e, beforeSubmit, actionName = 'submit') {
  // Avoid submit infinite loop
  if (document.querySelector('input[name="g-recaptcha-token"]')) {
    return;
  }

  const form = document.querySelector(formSelector);

  e.preventDefault();
  // eslint-disable-next-line no-undef
  grecaptcha.ready(() => {
    // eslint-disable-next-line no-undef
    grecaptcha.execute(recaptchaKey, { action: actionName }).then((token) => {
      const captchaToken = document.createElement('input');
      captchaToken.type = 'hidden';
      captchaToken.name = 'g-recaptcha-token';
      captchaToken.value = token;
      form.insertAdjacentElement('beforeend', captchaToken);
      beforeSubmit?.();
      form.submit();
    });
  });
}

export const getRecaptchaToken = (recaptchaKey, actionName = 'submit') => new Promise((resolve, reject) => {
  // eslint-disable-next-line no-undef
  grecaptcha.ready(() => {
    try {
      // eslint-disable-next-line no-undef
      grecaptcha.execute(recaptchaKey, { action: actionName })
        .then((token) => {
          resolve(token);
        });
    } catch (error) {
      reject(error);
    }
  });
});

export const addCaptchaToForm = async (formSelector, symfonyFormName) => {
  const form = document.getElementById(formSelector);

  if (!form) {
    return;
  }

  const inputName = `${symfonyFormName}[g-recaptcha-token]`;
  let existingCaptcha = form.querySelector(`input[name="${inputName}"]`);

  if (!existingCaptcha) {
    existingCaptcha = document.createElement('input');
    existingCaptcha.type = 'hidden';
    existingCaptcha.name = inputName;
  }

  existingCaptcha.value = await getRecaptchaToken(window.recaptcha, 'contact');

  form.appendChild(existingCaptcha);
};
